export default {
  en: {
    games: {
      lotto: 'Lottery'
    },
    messages: {
      total_price: 'Total',
      setNumber: 'Set number',
      creditChip: 'Credit Chip',
      rollingChip: 'Rolling Chip',
      sendList: 'Send List',
      sending: 'Sending',
      bet: 'Bet',
      clear: 'Clear',
      listEmpty: 'Empty',
      listWaitConfirm: 'Listing',
      reviewBeforeConfirm: 'Review',
      cancel: 'Cancel',
      systemSendedList: 'Listing has been sended',
      viewListing: 'View',
      continue: 'Continue',
      betPrice: 'Price',
      total: 'Total',
      confirmClear: 'Confirmation',
      clearAll: 'Clear All',
      confirm: 'Ok',
      close: 'Close',
      limitTicket: 'Number {number} limit {limit} ticket',
      error: 'Something went wrong please try agian',
      deleteAll: 'Clear all',
      deleteLast: 'Delete Last',
      randomNumber: 'Random',
      select: 'Add to List',
      fullCard: 'Full Card',
      halfCard: 'Half card'
    },
    rules: {
      stake: 'Betting Conditions'
    }
  },
  kh: {
    games: {
      lotto: 'Lottery'
    },
    messages: {
      total_price: 'Total',
      setNumber: 'Set number',
      creditChip: 'Credit Chip',
      rollingChip: 'Rolling Chip',
      sendList: 'Send List',
      sending: 'Sending',
      bet: 'Bet',
      clear: 'Clear',
      listEmpty: 'Empty',
      listWaitConfirm: 'Listing',
      reviewBeforeConfirm: 'Review',
      cancel: 'Cancel',
      systemSendedList: 'Listing has been sended',
      viewListing: 'View',
      continue: 'Continue',
      betPrice: 'Price',
      total: 'Total',
      confirmClear: 'Confirmation',
      clearAll: 'Clear All',
      confirm: 'Ok',
      close: 'Close',
      limitTicket: 'Number {number} limit {limit} ticket',
      error: 'Something went wrong please try agian',
      deleteAll: 'Clear all',
      deleteLast: 'Delete Last',
      randomNumber: 'Random',
      select: 'Add to List',
      fullCard: 'Full Card',
      halfCard: 'Half card'
    },
    rules: {
      stake: 'Betting Conditions'
    }

  },
  th: {
    games: {
      lotto: 'ลอตเตอรี่'
    },
    messages: {
      total_price: 'จำนวนเงินทั้งหมด',
      setNumber: 'โพยเลขที่',
      creditChip: 'ชิปเป็น',
      rollingChip: 'ชิปตาย',
      sendList: 'ยืนยัน',
      sending: 'ส่งโพย..',
      bet: 'แทงพนัน',
      clear: 'ล้างข้อมูล',
      listEmpty: 'ยังไม่มีรายการซื้อ',
      listWaitConfirm: 'รายการสั่งซื้อรอยืนยัน',
      reviewBeforeConfirm: 'ดูโพยอีกครั้งก่อนยืนยันการสั่งซื้อ',
      cancel: 'ยกเลิก',
      systemSendedList: 'ระบบได้ทำการส่งโพยของท่านเรียบร้อยแล้ว',
      viewListing: 'ดูโพย',
      continue: 'ซื้อเพิ่ม',
      betPrice: 'ราคา',
      total: 'รวม',
      confirmClear: 'ยืนยันการล้างข้อมูล',
      clearAll: 'ลบชุดตัวเลขที่คุณได้เลือกไว้ทั้งหมด',
      confirm: 'ยืนยัน',
      close: 'ปิด',
      limitTicket: 'เลข {number} ซื้อได้ไม่เกิน {limit} ใบ',
      error: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',

      deleteAll: 'ลบทั้งหมด',
      deleteLast: 'ลบตัวท้าย',
      randomNumber: 'สุ่มเลข',
      select: 'เลือก',
      fullCard: 'เต็มใบ',
      halfCard: 'ครึ่งใบ'
    },
    rules: {
      stake: 'เงื่อนไขการแทง'
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/lotto/messages/index.js